// extracted by mini-css-extract-plugin
module.exports = {"Controls":"Controls_Controls__dgBii","Buttons":"Controls_Buttons__1d6D6"};